const FIELDS = {
    BASE_FIELDS: [
        "isBrazilian",
        "id",
        "entityId",
        "name",
        "email",
        "birthdate",
        "affiliation",
        "gender",
        // "isCustomer",
    ],
    BRAZILIAN_FIELDS: [
        "cpf"
    ],
    FOREIGNER_FIELDS: [
        "passport",
        "postalCode",
        "address",
        "number",
        "city",
        // "complement",
        // "neighborhood",
        // "state"
    ],
    RESPONSIBLE_FIELDS: [
        "responsibleName",
        "responsibleEmail",
        "responsibleTaxVat"
    ]
}

// A method to validate whether the beneficiary has any missing fields.
// Returns true if so.
const beneficiaryFieldsValidator = (props) => {
    // Destructured props
    const {beneficiary} = props;

    // Additional validation to prevent any errors
    if (!beneficiary || Object?.keys(beneficiary).length === 0) {
        return false;
    }

    // The fields to look for in the beneficiary payload
    let targetFields = [...FIELDS.BASE_FIELDS];

    switch (beneficiary.isBrazilian) {
        case true:
            targetFields = [
                ...targetFields,
                ...FIELDS.BRAZILIAN_FIELDS
            ];

            break;
        case false:
            targetFields = [
                ...targetFields,
                ...FIELDS.FOREIGNER_FIELDS
            ];

            break;
        default:
            return false;
    }

    for (let i = 0; i < targetFields.length; i++) {
        const currentTargetField = targetFields[i];

        // If this condition is satisfied,
        // then it means that there's a missing field in the form.
        if (
            beneficiary[currentTargetField] === undefined ||
            beneficiary[currentTargetField] === null
        ) {
            return true;
        }
    }

    // At last, if there aren't any errors, then it returns false
    return false;
}

export default beneficiaryFieldsValidator;
